import React, { Component } from "react";
import { Api } from "../../../app-controller.js";

class ModalSolicitudMovimiento extends Component {
  render() {
    return (
      <>
        <div>
          {/*  <fieldset className="panel"> */}
          {/* <legend>Certificado de exportación</legend> */}
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div id="detalleCertificado">
                  <div className="row">
                    <div className="col-lg-3">
                      <div className="widget100 widget widget-stats bg-gradient-teal m-b-10">
                        <div className="stats-icon stats-icon-lg">
                          <i className="fab fa-lg fa-fw m-r-10 fa-wpforms"></i>
                        </div>
                        <div className="stats-content">
                          <div className="stats-title">Trámite</div>

                          <div className="stats-desc">
                            <h5>
                              {
                                this.props.state.solicitud_mov.accion
                                  .descripcion
                              }
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <div className="widget100 widget widget-stats bg-gradient-yellow m-b-10">
                        <div className="stats-icon stats-icon-lg">
                          <i className="fas fa-lg fa-fw m-r-10 fa-question-circle"></i>
                        </div>
                        <div className="stats-content">
                          <div className="stats-title">Tipo</div>

                          <div className="stats-desc">
                            <h5>
                              {
                                this.props.state.solicitud_mov.tramite
                                  .descripcion
                              }
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <div className="widget100 widget widget-stats bg-gradient-blue m-b-10">
                        <div className="stats-icon stats-icon-lg">
                          <i className="fas fa-lg fa-fw m-r-10 fa-clock"></i>
                        </div>
                        <div className="stats-content">
                          <div className="stats-title">Estado</div>

                          <div className="stats-desc">
                            <h5>
                              {
                                this.props.state.solicitud_mov.estatus
                                  .descripcion
                              }
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <div className="widget100 widget widget-stats bg-gradient-green m-b-10">
                        <div className="stats-icon stats-icon-lg">
                          <i className="fas fa-lg fa-fw m-r-10 fa-calendar-alt"></i>
                        </div>
                        <div className="stats-content">
                          <div className="stats-title">Fecha</div>

                          <div className="stats-desc">
                            <h5>
                              {this.props.state.solicitud_mov.fecha_solicitud
                                .substr(0, 10)
                                .split("-")
                                .reverse()
                                .join("/")}
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <hr />

                  <fieldset>
                    <legend>DATOS MOVIMIENTO</legend>

                    <div className="row">
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label>Folio de movimiento:</label>
                          <div className="form-control">
                            {this.props.state.movimiento.folio_movimiento}
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="form-group">
                          <label>Folio de egreso:</label>
                          <div className="form-control">
                            {
                              this.props.state.movimiento
                                .bitacora_producto_egreso
                                .folio_bitacora_producto
                            }
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-9">
                        <div className="form-group">
                          <label>Establecimiento que envía:</label>
                          <div className="form-control">
                            {
                              this.props.state.movimiento
                                .establecimiento_envia_nombre
                            }
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="form-group">
                          <label>Actividad envía:</label>
                          <div className="form-control">
                            {this.props.state.movimiento.actividad_envia.descripcion.toUpperCase()}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-9">
                        <div className="form-group">
                          <label>Establecimiento que recibe:</label>
                          <div className="form-control">
                            {
                              this.props.state.movimiento
                                .establecimiento_recibe_nombre
                            }
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="form-group">
                          <label>Actividad recibe:</label>
                          <div className="form-control">
                            {this.props.state.movimiento.actividad_recibe.descripcion.toUpperCase()}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-12">
                        <div className="form-group">
                          <label>Número de factura:</label>
                          <div className="form-control">
                            {
                              this.props.state.movimiento
                                .bitacora_producto_detalle_entrada.num_factura
                            }
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* </div> */}
                  </fieldset>

                  <fieldset>
                    <legend>DATOS PRODUCTO</legend>
                    <div className="row">
                      <div className="col-lg-2">
                        <div className="form-group">
                          <label>Número de registro:</label>
                          <div className="form-control">
                            {this.props.state.movimiento.producto.no_registro}
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-5">
                        <div className="form-group">
                          <label>Nombre comercial:</label>
                          <div className="form-control">
                            {
                              this.props.state.movimiento
                                .bitacora_producto_egreso
                                .producto_nombre_comercial
                            }
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-5">
                        <div className="form-group">
                          <label>Presentación:</label>
                          <div className="form-control">
                            {
                              this.props.state.movimiento
                                .bitacora_producto_egreso
                                .rel_producto_empaque_texto
                            }
                          </div>
                        </div>
                      </div>
                    </div>

                    <br />

                    <div className="row">
                      <div className="col-lg-12">
                        <table className="table table-striped mb-0 table-hover">
                          <thead>
                            <tr>
                              <th className="text-center">Lote</th>
                              <th className="text-center">Fecha fabricación</th>
                              <th className="text-center">Vencimiento lote</th>
                              <th className="text-center">Cantidad enviada</th>
                              {this.props.state.movimiento.formulario_acepta ? (
                                <th className="text-center">
                                  Cantidad aceptada
                                </th>
                              ) : null}
                            </tr>
                          </thead>
                          <tbody>
                            {this.props.state.movimiento
                              .rel_bitacora_producto_lote.length > 0
                              ? this.props.state.movimiento.rel_bitacora_producto_lote.map(
                                  (item, index) => (
                                    <tr key={index}>
                                      <td className="text-center" width={"20%"}>
                                        {item.num_lote}
                                      </td>
                                      <td className="text-center" width={"20%"}>
                                        {item.fecha_fabricacion
                                          .split(" ")[0]
                                          .split("-")
                                          .reverse()
                                          .join("/")}
                                      </td>
                                      <td className="text-center" width={"20%"}>
                                        {item.vencimiento_lote
                                          .split(" ")[0]
                                          .split("-")
                                          .reverse()
                                          .join("/")}
                                      </td>
                                      <td className="text-center" width={"20%"}>
                                        {item.cantidad_enviada}
                                      </td>
                                      {this.props.state.movimiento
                                        .formulario_acepta ? (
                                        <td
                                          className="text-center"
                                          width={"20%"}
                                        >
                                          {item.cantidad_aceptada ?? "N/A"}
                                        </td>
                                      ) : null}
                                    </tr>
                                  )
                                )
                              : null}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <br />

                    {this.props.state.movimiento.formulario_acepta ? (
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label htmlFor="observaciones">
                              Observaciones:
                            </label>
                            <textarea
                              name="observaciones"
                              id="observaciones"
                              className="form-control"
                              readOnly
                              value={
                                this.props.bitacora_movimiento
                                  ? this.props.bitacora_movimiento.observaciones
                                  : "N/A"
                              }
                              placeholder="Ingrese observaciones"
                            ></textarea>
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </fieldset>

                  <fieldset>
                    <legend>DOCUMENTOS</legend>

                    <div className="table-responsive">
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th className="text-center">Vista previa</th>
                            <th className="text-center">Documento</th>
                            <th className="text-center">Fecha carga</th>
                            <th className="text-center">Fecha aprobación</th>
                            <th className="text-center">Acción</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="text-center">
                              <img
                                alt="Vista previa"
                                className="rounded btn"
                                data-file={
                                  Api.url +
                                  `app/documentoMP/?id=${this.props.state.movimiento.id}`
                                }
                                onClick={this.props.handlePrevia}
                                width="60"
                                src={
                                  Api.url +
                                  `app/documentoMP/?id=${this.props.state.movimiento.id}&thumb=1`
                                }
                              />
                            </td>
                            <td className="text-center">
                              {this.props.state.solicitud_mov.tipo_documento.toUpperCase()}
                            </td>
                            <td className="text-center">
                              {this.props.state.movimiento
                                .bitacora_producto_detalle_entrada.created !==
                              null
                                ? this.props.state.movimiento.bitacora_producto_detalle_entrada.created
                                    .substr(0, 10)
                                    .split("-")
                                    .reverse()
                                    .join("/")
                                : ""}
                            </td>
                            <td className="text-center">
                              {this.props.state.solicitud_mov
                                .fecha_aprueba_sinaip
                                ? this.props.state.solicitud_mov.fecha_aprueba_sinaip
                                    .split("-")
                                    .reverse()
                                    .join("-")
                                    .replaceAll("-", "/")
                                : "N/A"}
                            </td>
                            <td className="text-center">
                              <div className="btn-group">
                                <a
                                  href={
                                    Api.url +
                                    `app/documentoMP/?id=${this.props.state.movimiento.id}&download=1`
                                  }
                                  className="btn btn-primary"
                                >
                                  <i className="fas fa-file-download"></i>
                                </a>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </fieldset>

                  <hr />

                  <div className="row">
                    <div className="col-lg-12">
                      <div className="btn-group  pull-left">
                        <button
                          className="btn btn-white "
                          onClick={() => {
                            this.props.closeModalMovimientos();
                          }}
                        >
                          Regresar
                        </button>
                      </div>

                      <div className="btn-group pull-right col-md-4">
                        <button
                          onClick={this.props.handleMovimientoProducto}
                          value="4"
                          data-solicitud_id={this.props.state.solicitud_mov.id}
                          id="rechazar_mov"
                          className="btn btn-danger"
                        >
                          Rechazar
                        </button>
                        <button
                          onClick={this.props.handleMovimientoProducto}
                          value="15"
                          data-solicitud_id={this.props.state.solicitud_mov.id}
                          id="aprobar_mov"
                          className="btn btn-success "
                        >
                          Aceptar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* 
              </fieldset> */}
        </div>
      </>
    );
  }
}

export default ModalSolicitudMovimiento;
